module.exports = __webpack_public_path__ + "static/media/pirate.075a710f.png";